import React, { useState } from "react";
import Storage from "../Storage";
import Axios from "axios";
import { toast } from "react-toastify";
import Translate, { Message } from "../messages/GeralMessages";
import { SpreadController } from "../../base/controllers/SpreadController";


export function MoneyMask(v, n) {
  let i, f;
  i = Math.floor(v);
  f = v - i;
  if (n !== 0) {
    return `${i.toLocaleString()},${f.toFixed(n).substr(2)}`;
  } else {
    return `${i.toLocaleString()}`;
  }
}

export function CheckCreditCard(numb) {
  const regex = new RegExp("^[0-9]{13,19}$");
  if (!regex.test(numb)) {
    return false;
  }
  return luhnck(numb);
}

export const Currencies = [
  { name: "Real (BRL)", value: 0, code: "BRL", currencyCode: "BRL", mask: "R$" },
  { name: "Dolar (USD)", value: 1, code: "USDBRL", currencyCode: "USD", mask: "$" },
  // { name: "EURO (EUR)", value: 2, code: "EURBRL", currencyCode: "EUR", mask: "€" },
];

export const CurrenciesObj = {
  BRL: 0,
  USDBRL: 1,
  EURBRL: 2,
};

export function CurrencyOption({ report }) {
  const [currency, setCurrency] = useState(Storage.getCurrency())

  function handleChange(evt) {
    Storage.setCurrency(evt.target.value);
    setCurrency(evt.target.value);
    report(evt.target.value)
  }

  return (
    <div className="form-group">
      <span>{Translate(Message.SelectCurrency)}</span>
      <select className="form-control" onChange={evt => handleChange(evt)}>
        <option>{Translate(Message.Select)}</option>
        {Currencies.map(item => (
          <option value={item.value} selected={item.value == currency ? true : false}>{item.name}</option>
        ))}
      </select>
    </div>
  )
}

export const ValueType = {
  Value: 0,
  Percentage: 1,
}

export function CurrencyConverter(num) {
  const result = Currencies.filter(x => x.value == num);
  if (result.length > 0) {
    return result[0].currencyCode;
  } else {
    return "USD";
  }
}

export function CurrencyConverterByCode(code) {
  const result = Currencies.filter(x => x.currencyCode == code);
  if (result.length > 0) {
    return result[0].mask;
  } else {
    return "$";
  }
}

export function ProcessValue(value) {
  const baseCurrency = Storage.getCurrency();
  const quotation = Storage.getQuotationData();

  if (!baseCurrency || !quotation) {
    return `R$${MoneyMask(value, 2)}`;
  } else {
    if (baseCurrency == CurrenciesObj.USDBRL) {
      const base = value / parseFloat(quotation.USDBRL.bid);
      const result = base + (base * quotation.spread);
      return `$${MoneyMask(result, 2)}`;
    } else if (baseCurrency == CurrenciesObj.EURBRL) {
      const base = value / parseFloat(quotation.EURBRL.bid);
      const result = base + (base * quotation.spread);
      return `€${MoneyMask(result, 2)}`;
    } else {
      return `R$${MoneyMask(parseFloat(value) + (parseFloat(value) * quotation.spread), 2)}`;
    }
  }
}

export function ProcessCurrency() {
  const baseCurrency = Storage.getCurrency();
  const quotation = Storage.getQuotationData();

  if (!baseCurrency || !quotation) {
    return `R$`;
  } else {
    if (baseCurrency == CurrenciesObj.USDBRL) {
      return `$`;
    } else if (baseCurrency == CurrenciesObj.EURBRL) {
      return `€`;
    } else {
      return `R$`;
    }
  }
}

export function ProcessOnlyValue(value) {
  console.log("!Valor!", value);
  const baseCurrency = Storage.getCurrency();
  const quotation = Storage.getQuotationData();

  if (!baseCurrency || !quotation) {
    return value.toFixed(2);
  } else {
    if (baseCurrency == CurrenciesObj.USDBRL) {
      const base = value / parseFloat(quotation.USDBRL.bid);
      const result = base + (base * quotation.spread);
      return result.toFixed(2);
    } else if (baseCurrency == CurrenciesObj.EURBRL) {
      const base = value / parseFloat(quotation.EURBRL.bid);
      const result = base + (base * quotation.spread);
      return result.toFixed(2);
    } else {
      return (parseFloat(value) + (parseFloat(value) * quotation.spread)).toFixed(2);
    }
  }
}

export function ProcessProfit(profits, value, country) {
  const oldValue = value;
  if (profits == undefined || profits.length == 0) {
    return value;
  } else {
    for (let s in profits) {
      if (profits[s].isDefault == true || country == profits[s].country || profits[s].userId == Storage.getUserData().id) {
        value += (value * profits[s].value)
      }
    }
  }
  console.log("Valor processado", profits, value, oldValue);
  return value;
}

export function RegisterMoneyRules() {
  Axios.get(`https://economia.awesomeapi.com.br/last/USD-BRL,EUR-BRL,BTC-BRL`, {})
    .then(function (response) {
      SpreadController.List(res => {
        let result = response.data;
        if (res.length > 0) {
          result.spread = res[0].value;
        }
        Storage.setQuotationData(result);
      })

    })
    .catch(function (error) {
      if (error) {
        toast.error(Translate(Message.CannotFindCurrency));
      }
    });
}

export function GetCardBrand(number) {
  // visa
  var re = new RegExp("^4");
  if (number.match(re) != null)
    return "Visa";

  // Mastercard 
  // Updated for Mastercard 2017 BINs expansion
  if (/^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(number))
    return "Mastercard";

  // AMEX
  re = new RegExp("^3[47]");
  if (number.match(re) != null)
    return "AMEX";

  // Discover
  re = new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
  if (number.match(re) != null)
    return "Discover";

  // Diners
  re = new RegExp("^36");
  if (number.match(re) != null)
    return "Diners";

  // Diners - Carte Blanche
  re = new RegExp("^30[0-5]");
  if (number.match(re) != null)
    return "Diners - Carte Blanche";

  // JCB
  re = new RegExp("^35(2[89]|[3-8][0-9])");
  if (number.match(re) != null)
    return "JCB";

  // Visa Electron
  re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
  if (number.match(re) != null)
    return "Visa Electron";

  return "";
}


const luhnck = (val) => {
  let validsum = 0;
  let k = 1;
  for (let l = val.length - 1; l >= 0; l--) {
    let calck = 0;
    calck = Number(val.charAt(l)) * k;
    if (calck > 9) {
      validsum = validsum + 1;
      calck = calck - 10;
    }
    validsum = validsum + calck;
    if (k == 1) {
      k = 2;
    } else {
      k = 1;
    }
  }
  console.log("Resultados", val, validsum % 10 == 0);
  return validsum % 10 == 0;
};

export function CalculoICMS(baseTax, price) {
  let tax = 0;
  if (baseTax != undefined) {
    tax = baseTax.value;
  }
  let response = { total: 0, taxCost: 0 };

  const product = price + (price * (tax / 100));

  console.log("Calculo ICMS Parte 1", product);

  const result = product + (product * (tax / 100));

  console.log("Calculo ICMS Parte 2", result);
  response.taxCost = result - price;
  response.total = result;
  return response;
}

export const States = [
  {
    "LongName": "Acre",
    "ShortName": "AC"
  },
  {
    "LongName": "Alagoas",
    "ShortName": "AL"
  },
  {
    "LongName": "Amapá",
    "ShortName": "AP"
  },
  {
    "LongName": "Amazonas",
    "ShortName": "AM"
  },
  {
    "LongName": "Bahia",
    "ShortName": "BA"
  },
  {
    "LongName": "Ceará",
    "ShortName": "CE"
  },
  {
    "LongName": "Distrito Federal",
    "ShortName": "DF"
  },
  {
    "LongName": "Espírito Santo",
    "ShortName": "ES"
  },
  {
    "LongName": "Goiás",
    "ShortName": "GO"
  },
  {
    "LongName": "Maranhão",
    "ShortName": "MA"
  },
  {
    "LongName": "Mato Grosso",
    "ShortName": "MT"
  },
  {
    "LongName": "Mato Grosso do Sul",
    "ShortName": "MS"
  },
  {
    "LongName": "Minas Gerais",
    "ShortName": "MG"
  },
  {
    "LongName": "Pará",
    "ShortName": "PA"
  },
  {
    "LongName": "Paraíba",
    "ShortName": "PB"
  },
  {
    "LongName": "Paraná",
    "ShortName": "PR"
  },
  {
    "LongName": "Pernambuco",
    "ShortName": "PE"
  },
  {
    "LongName": "Piauí",
    "ShortName": "PI"
  },
  {
    "LongName": "Rio de Janeiro",
    "ShortName": "RJ"
  },
  {
    "LongName": "Rio Grande do Norte",
    "ShortName": "RN"
  },
  {
    "LongName": "Rio Grande do Sul",
    "ShortName": "RS"
  },
  {
    "LongName": "Rondônia",
    "ShortName": "RO"
  },
  {
    "LongName": "Roraima",
    "ShortName": "RR"
  },
  {
    "LongName": "Santa Catarina",
    "ShortName": "SC"
  },
  {
    "LongName": "São Paulo",
    "ShortName": "SP"
  },
  {
    "LongName": "Sergipe",
    "ShortName": "SE"
  },
  {
    "LongName": "Tocantins",
    "ShortName": "TO"
  }
];

export const Countries = [
  {
    "Name": "Afeganistão",
    "Code": "AF",
    "Term": "AF - Afeganistão"
  },
  {
    "Name": "África do Sul",
    "Code": "ZA",
    "Term": "ZA - África do Sul"
  },
  {
    "Name": "Albânia",
    "Code": "AL",
    "Term": "AL - Albânia"
  },
  {
    "Name": "Alemanha",
    "Code": "DE",
    "Term": "DE - Alemanha"
  },
  {
    "Name": "Andorra",
    "Code": "AD",
    "Term": "AD - Andorra"
  },
  {
    "Name": "Angola",
    "Code": "AO",
    "Term": "AO - Angola"
  },
  {
    "Name": "Anguila",
    "Code": "AI",
    "Term": "AI - Anguila"
  },
  {
    "Name": "Antártica",
    "Code": "AQ",
    "Term": "AQ - Antártica"
  },
  {
    "Name": "Antígua e Barbuda",
    "Code": "AG",
    "Term": "AG - Antígua e Barbuda"
  },
  {
    "Name": "Arábia Saudita",
    "Code": "SA",
    "Term": "SA - Arábia Saudita"
  },
  {
    "Name": "Argélia",
    "Code": "DZ",
    "Term": "DZ - Argélia"
  },
  {
    "Name": "Argentina",
    "Code": "AR",
    "Term": "AR - Argentina"
  },
  {
    "Name": "Armênia",
    "Code": "AM",
    "Term": "AM - Armênia"
  },
  {
    "Name": "Aruba",
    "Code": "AW",
    "Term": "AW - Aruba"
  },
  {
    "Name": "Austrália",
    "Code": "AU",
    "Term": "AU - Austrália"
  },
  {
    "Name": "Áustria",
    "Code": "AT",
    "Term": "AT - Áustria"
  },
  {
    "Name": "Azerbaijão",
    "Code": "AZ",
    "Term": "AZ - Azerbaijão"
  },
  {
    "Name": "Bahamas",
    "Code": "BS",
    "Term": "BS - Bahamas"
  },
  {
    "Name": "Bahrein",
    "Code": "BH",
    "Term": "BH - Bahrein"
  },
  {
    "Name": "Bangladesh",
    "Code": "BD",
    "Term": "BD - Bangladesh"
  },
  {
    "Name": "Barbados",
    "Code": "BB",
    "Term": "BB - Barbados"
  },
  {
    "Name": "Belarus",
    "Code": "BY",
    "Term": "BY - Belarus"
  },
  {
    "Name": "Bélgica",
    "Code": "BE",
    "Term": "BE - Bélgica"
  },
  {
    "Name": "Belize",
    "Code": "BZ",
    "Term": "BZ - Belize"
  },
  {
    "Name": "Benin",
    "Code": "BJ",
    "Term": "BJ - Benin"
  },
  {
    "Name": "Bermudas",
    "Code": "BM",
    "Term": "BM - Bermudas"
  },
  {
    "Name": "Bolívia",
    "Code": "BO",
    "Term": "BO - Bolívia"
  },
  {
    "Name": "Bósnia e Herzegovina",
    "Code": "BA",
    "Term": "BA - Bósnia e Herzegovina"
  },
  {
    "Name": "Botsuana",
    "Code": "BW",
    "Term": "BW - Botsuana"
  },
  {
    "Name": "Brasil",
    "Code": "BR",
    "Term": "BR - Brasil"
  },
  {
    "Name": "Brunei",
    "Code": "BN",
    "Term": "BN - Brunei"
  },
  {
    "Name": "Bulgária",
    "Code": "BG",
    "Term": "BG - Bulgária"
  },
  {
    "Name": "Burkina Faso",
    "Code": "BF",
    "Term": "BF - Burkina Faso"
  },
  {
    "Name": "Burundi",
    "Code": "BI",
    "Term": "BI - Burundi"
  },
  {
    "Name": "Butão",
    "Code": "BT",
    "Term": "BT - Butão"
  },
  {
    "Name": "Cabo Verde",
    "Code": "CV",
    "Term": "CV - Cabo Verde"
  },
  {
    "Name": "Camarões",
    "Code": "CM",
    "Term": "CM - Camarões"
  },
  {
    "Name": "Camboja",
    "Code": "KH",
    "Term": "KH - Camboja"
  },
  {
    "Name": "Canadá",
    "Code": "CA",
    "Term": "CA - Canadá"
  },
  {
    "Name": "Cazaquistão",
    "Code": "KZ",
    "Term": "KZ - Cazaquistão"
  },
  {
    "Name": "Chade",
    "Code": "TD",
    "Term": "TD - Chade"
  },
  {
    "Name": "Chile",
    "Code": "CL",
    "Term": "CL - Chile"
  },
  {
    "Name": "China",
    "Code": "CN",
    "Term": "CN - China"
  },
  {
    "Name": "Chipre",
    "Code": "CY",
    "Term": "CY - Chipre"
  },
  {
    "Name": "Cidade do Vaticano",
    "Code": "VA",
    "Term": "VA - Cidade do Vaticano"
  },
  {
    "Name": "Cingapura",
    "Code": "SG",
    "Term": "SG - Cingapura"
  },
  {
    "Name": "Colômbia",
    "Code": "CO",
    "Term": "CO - Colômbia"
  },
  {
    "Name": "Comores",
    "Code": "KM",
    "Term": "KM - Comores"
  },
  {
    "Name": "Coréia do Norte",
    "Code": "KP",
    "Term": "KP - Coréia do Norte"
  },
  {
    "Name": "Coréia do Sul",
    "Code": "KR",
    "Term": "KR - Coréia do Sul"
  },
  {
    "Name": "Costa do Marfim",
    "Code": "CI",
    "Term": "CI - Costa do Marfim"
  },
  {
    "Name": "Costa Rica",
    "Code": "CR",
    "Term": "CR - Costa Rica"
  },
  {
    "Name": "Croácia",
    "Code": "HR",
    "Term": "HR - Croácia"
  },
  {
    "Name": "Cuba",
    "Code": "CU",
    "Term": "CU - Cuba"
  },
  {
    "Name": "Curaçao",
    "Code": "CW",
    "Term": "CW - Curaçao"
  },
  {
    "Name": "Dinamarca",
    "Code": "DK",
    "Term": "DK - Dinamarca"
  },
  {
    "Name": "Djibouti",
    "Code": "DJ",
    "Term": "DJ - Djibouti"
  },
  {
    "Name": "Dominica",
    "Code": "DM",
    "Term": "DM - Dominica"
  },
  {
    "Name": "Egito",
    "Code": "EG",
    "Term": "EG - Egito"
  },
  {
    "Name": "El Salvador",
    "Code": "SV",
    "Term": "SV - El Salvador"
  },
  {
    "Name": "Emirados Árabes Unidos",
    "Code": "AE",
    "Term": "AE - Emirados Árabes Unidos"
  },
  {
    "Name": "Equador",
    "Code": "EC",
    "Term": "EC - Equador"
  },
  {
    "Name": "Eritreia",
    "Code": "ER",
    "Term": "ER - Eritreia"
  },
  {
    "Name": "Eslováquia",
    "Code": "SK",
    "Term": "SK - Eslováquia"
  },
  {
    "Name": "Eslovênia",
    "Code": "SI",
    "Term": "SI - Eslovênia"
  },
  {
    "Name": "Espanha",
    "Code": "ES",
    "Term": "ES - Espanha"
  },
  {
    "Name": "Estados Federados da Micronésia",
    "Code": "FM",
    "Term": "FM - Estados Federados da Micronésia"
  },
  {
    "Name": "Estados Unidos da América",
    "Code": "US",
    "Term": "US - Estados Unidos da América"
  },
  {
    "Name": "Estônia",
    "Code": "EE",
    "Term": "EE - Estônia"
  },
  {
    "Name": "Eswatini",
    "Code": "SZ",
    "Term": "SZ - Eswatini"
  },
  {
    "Name": "Etiópia",
    "Code": "ET",
    "Term": "ET - Etiópia"
  },
  {
    "Name": "Fiji",
    "Code": "FJ",
    "Term": "FJ - Fiji"
  },
  {
    "Name": "Filipinas",
    "Code": "PH",
    "Term": "PH - Filipinas"
  },
  {
    "Name": "Finlândia",
    "Code": "FI",
    "Term": "FI - Finlândia"
  },
  {
    "Name": "França",
    "Code": "FR",
    "Term": "FR - França"
  },
  {
    "Name": "Gabão",
    "Code": "GA",
    "Term": "GA - Gabão"
  },
  {
    "Name": "Gâmbia",
    "Code": "GM",
    "Term": "GM - Gâmbia"
  },
  {
    "Name": "Gana",
    "Code": "GH",
    "Term": "GH - Gana"
  },
  {
    "Name": "Geórgia",
    "Code": "GE",
    "Term": "GE - Geórgia"
  },
  {
    "Name": "Geórgia do Sul e as Ilhas Sandwich do Sul",
    "Code": "GS",
    "Term": "GS - Geórgia do Sul e as Ilhas Sandwich do Sul"
  },
  {
    "Name": "Gibraltar",
    "Code": "GI",
    "Term": "GI - Gibraltar"
  },
  {
    "Name": "Grécia",
    "Code": "GR",
    "Term": "GR - Grécia"
  },
  {
    "Name": "Grenada",
    "Code": "GD",
    "Term": "GD - Grenada"
  },
  {
    "Name": "Gronelândia",
    "Code": "GL",
    "Term": "GL - Gronelândia"
  },
  {
    "Name": "Guadalupe",
    "Code": "GP",
    "Term": "GP - Guadalupe"
  },
  {
    "Name": "Guam",
    "Code": "GU",
    "Term": "GU - Guam"
  },
  {
    "Name": "Guatemala",
    "Code": "GT",
    "Term": "GT - Guatemala"
  },
  {
    "Name": "Guernsey",
    "Code": "GG",
    "Term": "GG - Guernsey"
  },
  {
    "Name": "Guiana",
    "Code": "GY",
    "Term": "GY - Guiana"
  },
  {
    "Name": "Guiana Francesa",
    "Code": "GF",
    "Term": "GF - Guiana Francesa"
  },
  {
    "Name": "Guiné",
    "Code": "GN",
    "Term": "GN - Guiné"
  },
  {
    "Name": "Guiné Equatorial",
    "Code": "GQ",
    "Term": "GQ - Guiné Equatorial"
  },
  {
    "Name": "Guiné-Bissau",
    "Code": "GW",
    "Term": "GW - Guiné-Bissau"
  },
  {
    "Name": "Haiti",
    "Code": "HT",
    "Term": "HT - Haiti"
  },
  {
    "Name": "Honduras",
    "Code": "HN",
    "Term": "HN - Honduras"
  },
  {
    "Name": "Hong Kong",
    "Code": "HK",
    "Term": "HK - Hong Kong"
  },
  {
    "Name": "Hungria",
    "Code": "HU",
    "Term": "HU - Hungria"
  },
  {
    "Name": "Iêmen",
    "Code": "YE",
    "Term": "YE - Iêmen"
  },
  {
    "Name": "Ilha Bouvet",
    "Code": "BV",
    "Term": "BV - Ilha Bouvet"
  },
  {
    "Name": "Ilha da Reunião",
    "Code": "RE",
    "Term": "RE - Ilha da Reunião"
  },
  {
    "Name": "Ilha de Man",
    "Code": "IM",
    "Term": "IM - Ilha de Man"
  },
  {
    "Name": "Ilha de Natal",
    "Code": "CX",
    "Term": "CX - Ilha de Natal"
  },
  {
    "Name": "Ilha Norfolk",
    "Code": "NF",
    "Term": "NF - Ilha Norfolk"
  },
  {
    "Name": "Ilhas Åland",
    "Code": "AX",
    "Term": "AX - Ilhas Åland"
  },
  {
    "Name": "Ilhas Cayman",
    "Code": "KY",
    "Term": "KY - Ilhas Cayman"
  },
  {
    "Name": "Ilhas Cocos",
    "Code": "CC",
    "Term": "CC - Ilhas Cocos"
  },
  {
    "Name": "Ilhas Cook",
    "Code": "CK",
    "Term": "CK - Ilhas Cook"
  },
  {
    "Name": "Ilhas Faroe",
    "Code": "FO",
    "Term": "FO - Ilhas Faroe"
  },
  {
    "Name": "Ilhas Malvinas",
    "Code": "FK",
    "Term": "FK - Ilhas Malvinas"
  },
  {
    "Name": "Ilhas Marianas do Norte",
    "Code": "MP",
    "Term": "MP - Ilhas Marianas do Norte"
  },
  {
    "Name": "Ilhas Marshall",
    "Code": "MH",
    "Term": "MH - Ilhas Marshall"
  },
  {
    "Name": "Ilhas Menores Distantes dos Estados Unidos",
    "Code": "UM",
    "Term": "UM - Ilhas Menores Distantes dos Estados Unidos"
  },
  {
    "Name": "Ilhas Pitcairn",
    "Code": "PN",
    "Term": "PN - Ilhas Pitcairn"
  },
  {
    "Name": "Ilhas Salomão",
    "Code": "SB",
    "Term": "SB - Ilhas Salomão"
  },
  {
    "Name": "Ilhas Turcas e Caicos",
    "Code": "TC",
    "Term": "TC - Ilhas Turcas e Caicos"
  },
  {
    "Name": "Ilhas Virgens (Reino Unido)",
    "Code": "VG",
    "Term": "VG - Ilhas Virgens (Reino Unido)"
  },
  {
    "Name": "Ilhas Virgens dos Estados Unidos",
    "Code": "VI",
    "Term": "VI - Ilhas Virgens dos Estados Unidos"
  },
  {
    "Name": "Índia",
    "Code": "IN",
    "Term": "IN - Índia"
  },
  {
    "Name": "Indonésia",
    "Code": "ID",
    "Term": "ID - Indonésia"
  },
  {
    "Name": "Irã",
    "Code": "IR",
    "Term": "IR - Irã"
  },
  {
    "Name": "Iraque",
    "Code": "IQ",
    "Term": "IQ - Iraque"
  },
  {
    "Name": "Irlanda",
    "Code": "IE",
    "Term": "IE - Irlanda"
  },
  {
    "Name": "Islândia",
    "Code": "IS",
    "Term": "IS - Islândia"
  },
  {
    "Name": "Israel",
    "Code": "IL",
    "Term": "IL - Israel"
  },
  {
    "Name": "Itália",
    "Code": "IT",
    "Term": "IT - Itália"
  },
  {
    "Name": "Jamaica",
    "Code": "JM",
    "Term": "JM - Jamaica"
  },
  {
    "Name": "Japão",
    "Code": "JP",
    "Term": "JP - Japão"
  },
  {
    "Name": "Jersey",
    "Code": "JE",
    "Term": "JE - Jersey"
  },
  {
    "Name": "Jordânia",
    "Code": "JO",
    "Term": "JO - Jordânia"
  },
  {
    "Name": "Kiribati",
    "Code": "KI",
    "Term": "KI - Kiribati"
  },
  {
    "Name": "Kosovo",
    "Code": "XK",
    "Term": "XK - Kosovo"
  },
  {
    "Name": "Kuwait",
    "Code": "KW",
    "Term": "KW - Kuwait"
  },
  {
    "Name": "Laos",
    "Code": "LA",
    "Term": "LA - Laos"
  },
  {
    "Name": "Lesotho",
    "Code": "LS",
    "Term": "LS - Lesotho"
  },
  {
    "Name": "Letônia",
    "Code": "LV",
    "Term": "LV - Letônia"
  },
  {
    "Name": "Líbano",
    "Code": "LB",
    "Term": "LB - Líbano"
  },
  {
    "Name": "Libéria",
    "Code": "LR",
    "Term": "LR - Libéria"
  },
  {
    "Name": "Líbia",
    "Code": "LY",
    "Term": "LY - Líbia"
  },
  {
    "Name": "Liechtenstein",
    "Code": "LI",
    "Term": "LI - Liechtenstein"
  },
  {
    "Name": "Lituânia",
    "Code": "LT",
    "Term": "LT - Lituânia"
  },
  {
    "Name": "Luxemburgo",
    "Code": "LU",
    "Term": "LU - Luxemburgo"
  },
  {
    "Name": "Macau",
    "Code": "MO",
    "Term": "MO - Macau"
  },
  {
    "Name": "Madagascar",
    "Code": "MG",
    "Term": "MG - Madagascar"
  },
  {
    "Name": "Malásia",
    "Code": "MY",
    "Term": "MY - Malásia"
  },
  {
    "Name": "Malauí",
    "Code": "MW",
    "Term": "MW - Malauí"
  },
  {
    "Name": "Maldivas",
    "Code": "MV",
    "Term": "MV - Maldivas"
  },
  {
    "Name": "Mali",
    "Code": "ML",
    "Term": "ML - Mali"
  },
  {
    "Name": "Malta",
    "Code": "MT",
    "Term": "MT - Malta"
  },
  {
    "Name": "Marrocos",
    "Code": "MA",
    "Term": "MA - Marrocos"
  },
  {
    "Name": "Martinica",
    "Code": "MQ",
    "Term": "MQ - Martinica"
  },
  {
    "Name": "Maurício",
    "Code": "MU",
    "Term": "MU - Maurício"
  },
  {
    "Name": "Mauritânia",
    "Code": "MR",
    "Term": "MR - Mauritânia"
  },
  {
    "Name": "Mayotte",
    "Code": "YT",
    "Term": "YT - Mayotte"
  },
  {
    "Name": "México",
    "Code": "MX",
    "Term": "MX - México"
  },
  {
    "Name": "Mianmar",
    "Code": "MM",
    "Term": "MM - Mianmar"
  },
  {
    "Name": "Moçambique",
    "Code": "MZ",
    "Term": "MZ - Moçambique"
  },
  {
    "Name": "Moldávia",
    "Code": "MD",
    "Term": "MD - Moldávia"
  },
  {
    "Name": "Mongólia",
    "Code": "MN",
    "Term": "MN - Mongólia"
  },
  {
    "Name": "Montenegro",
    "Code": "ME",
    "Term": "ME - Montenegro"
  },
  {
    "Name": "Montserrat",
    "Code": "MS",
    "Term": "MS - Montserrat"
  },
  {
    "Name": "Namíbia",
    "Code": "NA",
    "Term": "NA - Namíbia"
  },
  {
    "Name": "Nauru",
    "Code": "NR",
    "Term": "NR - Nauru"
  },
  {
    "Name": "Nepal",
    "Code": "NP",
    "Term": "NP - Nepal"
  },
  {
    "Name": "Nicarágua",
    "Code": "NI",
    "Term": "NI - Nicarágua"
  },
  {
    "Name": "Níger",
    "Code": "NE",
    "Term": "NE - Níger"
  },
  {
    "Name": "Nigéria",
    "Code": "NG",
    "Term": "NG - Nigéria"
  },
  {
    "Name": "Niue",
    "Code": "NU",
    "Term": "NU - Niue"
  },
  {
    "Name": "Norte da Macedônia",
    "Code": "MK",
    "Term": "MK - Norte da Macedônia"
  },
  {
    "Name": "Noruega",
    "Code": "NO",
    "Term": "NO - Noruega"
  },
  {
    "Name": "Nova Caledônia",
    "Code": "NC",
    "Term": "NC - Nova Caledônia"
  },
  {
    "Name": "Nova Zelândia",
    "Code": "NZ",
    "Term": "NZ - Nova Zelândia"
  },
  {
    "Name": "Omã",
    "Code": "OM",
    "Term": "OM - Omã"
  },
  {
    "Name": "Ouvido e Ilhas McDonald",
    "Code": "HM",
    "Term": "HM - Ouvido e Ilhas McDonald"
  },
  {
    "Name": "Países Baixos",
    "Code": "NL",
    "Term": "NL - Países Baixos"
  },
  {
    "Name": "Países Baixos Caribenhos",
    "Code": "BQ",
    "Term": "BQ - Países Baixos Caribenhos"
  },
  {
    "Name": "Palau",
    "Code": "PW",
    "Term": "PW - Palau"
  },
  {
    "Name": "Palestina",
    "Code": "PS",
    "Term": "PS - Palestina"
  },
  {
    "Name": "Panamá",
    "Code": "PA",
    "Term": "PA - Panamá"
  },
  {
    "Name": "Papua Nova Guiné",
    "Code": "PG",
    "Term": "PG - Papua Nova Guiné"
  },
  {
    "Name": "Paquistão",
    "Code": "PK",
    "Term": "PK - Paquistão"
  },
  {
    "Name": "Paraguai",
    "Code": "PY",
    "Term": "PY - Paraguai"
  },
  {
    "Name": "Peru",
    "Code": "PE",
    "Term": "PE - Peru"
  },
  {
    "Name": "Polinésia Francesa",
    "Code": "PF",
    "Term": "PF - Polinésia Francesa"
  },
  {
    "Name": "Polônia",
    "Code": "PL",
    "Term": "PL - Polônia"
  },
  {
    "Name": "Porto Rico",
    "Code": "PR",
    "Term": "PR - Porto Rico"
  },
  {
    "Name": "Portugal",
    "Code": "PT",
    "Term": "PT - Portugal"
  },
  {
    "Name": "Principado de Mônaco",
    "Code": "MC",
    "Term": "MC - Principado de Mônaco"
  },
  {
    "Name": "Qatar",
    "Code": "QA",
    "Term": "QA - Qatar"
  },
  {
    "Name": "Quênia",
    "Code": "KE",
    "Term": "KE - Quênia"
  },
  {
    "Name": "Quirguizistão",
    "Code": "KG",
    "Term": "KG - Quirguizistão"
  },
  {
    "Name": "Reino Unido",
    "Code": "GB",
    "Term": "GB - Reino Unido"
  },
  {
    "Name": "República Centro-Africana",
    "Code": "CF",
    "Term": "CF - República Centro-Africana"
  },
  {
    "Name": "República Democrática do Congo",
    "Code": "CD",
    "Term": "CD - República Democrática do Congo"
  },
  {
    "Name": "República do Congo",
    "Code": "CG",
    "Term": "CG - República do Congo"
  },
  {
    "Name": "República Dominicana",
    "Code": "DO",
    "Term": "DO - República Dominicana"
  },
  {
    "Name": "Romênia",
    "Code": "RO",
    "Term": "RO - Romênia"
  },
  {
    "Name": "Ruanda",
    "Code": "RW",
    "Term": "RW - Ruanda"
  },
  {
    "Name": "Rússia",
    "Code": "RU",
    "Term": "RU - Rússia"
  },
  {
    "Name": "Saara Ocidental",
    "Code": "EH",
    "Term": "EH - Saara Ocidental"
  },
  {
    "Name": "Samoa",
    "Code": "WS",
    "Term": "WS - Samoa"
  },
  {
    "Name": "Samoa Americana",
    "Code": "AS",
    "Term": "AS - Samoa Americana"
  },
  {
    "Name": "Santa Helena, Ascensão e Tristão da Cunha",
    "Code": "SH",
    "Term": "SH - Santa Helena, Ascensão e Tristão da Cunha"
  },
  {
    "Name": "Santa Lúcia",
    "Code": "LC",
    "Term": "LC - Santa Lúcia"
  },
  {
    "Name": "Santo Bartolomeu",
    "Code": "BL",
    "Term": "BL - Santo Bartolomeu"
  },
  {
    "Name": "São Marino",
    "Code": "SM",
    "Term": "SM - São Marino"
  },
  {
    "Name": "São Martinho",
    "Code": "MF",
    "Term": "MF - São Martinho"
  },
  {
    "Name": "São Pedro e Miquelon",
    "Code": "PM",
    "Term": "PM - São Pedro e Miquelon"
  },
  {
    "Name": "São Tomé e Príncipe",
    "Code": "ST",
    "Term": "ST - São Tomé e Príncipe"
  },
  {
    "Name": "São Vicente e as Granadinas",
    "Code": "VC",
    "Term": "VC - São Vicente e as Granadinas"
  },
  {
    "Name": "Senegal",
    "Code": "SN",
    "Term": "SN - Senegal"
  },
  {
    "Name": "Serra Leoa",
    "Code": "SL",
    "Term": "SL - Serra Leoa"
  },
  {
    "Name": "Sérvia",
    "Code": "RS",
    "Term": "RS - Sérvia"
  },
  {
    "Name": "Seychelles",
    "Code": "SC",
    "Term": "SC - Seychelles"
  },
  {
    "Name": "Sint Maarten",
    "Code": "SX",
    "Term": "SX - Sint Maarten"
  },
  {
    "Name": "Síria",
    "Code": "SY",
    "Term": "SY - Síria"
  },
  {
    "Name": "Somália",
    "Code": "SO",
    "Term": "SO - Somália"
  },
  {
    "Name": "Sri Lanka",
    "Code": "LK",
    "Term": "LK - Sri Lanka"
  },
  {
    "Name": "St. Kitts e Nevis",
    "Code": "KN",
    "Term": "KN - St. Kitts e Nevis"
  },
  {
    "Name": "Sudão",
    "Code": "SD",
    "Term": "SD - Sudão"
  },
  {
    "Name": "Sudão do Sul",
    "Code": "SS",
    "Term": "SS - Sudão do Sul"
  },
  {
    "Name": "Suécia",
    "Code": "SE",
    "Term": "SE - Suécia"
  },
  {
    "Name": "Suíça",
    "Code": "CH",
    "Term": "CH - Suíça"
  },
  {
    "Name": "Suriname",
    "Code": "SR",
    "Term": "SR - Suriname"
  },
  {
    "Name": "Svalbard e Jan Mayen",
    "Code": "SJ",
    "Term": "SJ - Svalbard e Jan Mayen"
  },
  {
    "Name": "Tailândia",
    "Code": "TH",
    "Term": "TH - Tailândia"
  },
  {
    "Name": "Taiwan",
    "Code": "TW",
    "Term": "TW - Taiwan"
  },
  {
    "Name": "Tajiquistão",
    "Code": "TJ",
    "Term": "TJ - Tajiquistão"
  },
  {
    "Name": "Tanzânia",
    "Code": "TZ",
    "Term": "TZ - Tanzânia"
  },
  {
    "Name": "Tcheca",
    "Code": "CZ",
    "Term": "CZ - Tcheca"
  },
  {
    "Name": "Território Britânico do Oceano Índico",
    "Code": "IO",
    "Term": "IO - Território Britânico do Oceano Índico"
  },
  {
    "Name": "Territórios Franceses do Sul e Antártico",
    "Code": "TF",
    "Term": "TF - Territórios Franceses do Sul e Antártico"
  },
  {
    "Name": "Timor Leste",
    "Code": "TL",
    "Term": "TL - Timor Leste"
  },
  {
    "Name": "Togo",
    "Code": "TG",
    "Term": "TG - Togo"
  },
  {
    "Name": "Tokelau",
    "Code": "TK",
    "Term": "TK - Tokelau"
  },
  {
    "Name": "Tonga",
    "Code": "TO",
    "Term": "TO - Tonga"
  },
  {
    "Name": "Trinidad e Tobago",
    "Code": "TT",
    "Term": "TT - Trinidad e Tobago"
  },
  {
    "Name": "Tunísia",
    "Code": "TN",
    "Term": "TN - Tunísia"
  },
  {
    "Name": "Turcomenistão",
    "Code": "TM",
    "Term": "TM - Turcomenistão"
  },
  {
    "Name": "Turquia",
    "Code": "TR",
    "Term": "TR - Turquia"
  },
  {
    "Name": "Tuvalu",
    "Code": "TV",
    "Term": "TV - Tuvalu"
  },
  {
    "Name": "Ucrânia",
    "Code": "UA",
    "Term": "UA - Ucrânia"
  },
  {
    "Name": "Uganda",
    "Code": "UG",
    "Term": "UG - Uganda"
  },
  {
    "Name": "Uruguai",
    "Code": "UY",
    "Term": "UY - Uruguai"
  },
  {
    "Name": "Uzbequistão",
    "Code": "UZ",
    "Term": "UZ - Uzbequistão"
  },
  {
    "Name": "Vanuatu",
    "Code": "VU",
    "Term": "VU - Vanuatu"
  },
  {
    "Name": "Venezuela",
    "Code": "VE",
    "Term": "VE - Venezuela"
  },
  {
    "Name": "Vietnã",
    "Code": "VN",
    "Term": "VN - Vietnã"
  },
  {
    "Name": "Wallis e Futuna",
    "Code": "WF",
    "Term": "WF - Wallis e Futuna"
  },
  {
    "Name": "Zâmbia",
    "Code": "ZM",
    "Term": "ZM - Zâmbia"
  },
  {
    "Name": "Zimbábue",
    "Code": "ZW",
    "Term": "ZW - Zimbábue"
  }
]